import { useMemo } from 'react';
import { useDebounce } from '@/shared/hooks/use-debounce';

type Addon = {
  id: string;
  name: string;
  description: string;
  price: string;
  image: string;
  addon_category_id: string;
};

type AddonCategory = {
  id: string;
  name: string;
  addons: Addon[];
  select_min: number;
  select_max: number;
  mandatory: number;
};

type Product = {
  addon_categories: AddonCategory[];
};

export function useFilteredAddons(product: Product | undefined, searchTerm: string) {
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  const filteredAddonCategories = useMemo(() => {
    if (!product?.addon_categories) return [];

    const searchTerm = debouncedSearchTerm.toLowerCase();

    return product.addon_categories
      .map(category => ({
        ...category,
        addons: category.addons.filter(
          addon =>
            addon.name.toLowerCase().includes(searchTerm) ||
            addon.description?.toLowerCase().includes(searchTerm) ||
            // Tipado como texto, mas a API do cardápio manda número.
            String(addon.price).includes(searchTerm)
        ),
      }))
      .filter(category => category.addons.length > 0);
  }, [product?.addon_categories, debouncedSearchTerm]);

  return filteredAddonCategories;
}
